import { isHiddenKontentItem } from '../is-hidden-kontent-item'
import { MultipleItemResponse, fetchContent } from './fetchContent'

export const getAllSitemapPaths = async (preview?: boolean) => {
  let paths = []

  const languages = ['nl', 'en', 'de']
  for (const language of languages) {
    const response: MultipleItemResponse<any> = await fetchContent({
      path: '',
      preview,
      params: {
        elements: ['url_slug', 'seo_metadata__seo_indexing'],
        'system.type[in]': [
          'category_page',
          'brand_page',
          'brands_page',
          'theme_page',
          'content_page',
          'contact_page',
          'search_page',
          'faq_page',
          'stores_page',
          'newsletter_page',
          'tours_page',
          'news_overview_page',
          'return_page',
          'rich_experience_page',
        ],
        language,
      },
    })

    // Strip out pages that should not be visible in search engines
    const filteredItems = response.items.filter((item) => {
      const { seo_metadata__seo_indexing } = item.elements
      return !isHiddenKontentItem(seo_metadata__seo_indexing)
    })

    filteredItems.forEach((item) => {
      if (item.system.language === language && item.elements.url_slug.value.length) {
        const slug = item.elements.url_slug.value.split('/')
        paths.push({
          params: { lang: language, slug: [...slug] },
          pageType: item.system.type,
          lastmod: item.system.last_modified,
        })
      }
    })

    // Get store detail pages
    const storesPage = filteredItems.find((item) => item.system.type === 'stores_page')
    const fetchStoreSlugs: MultipleItemResponse<any> = await fetchContent({
      path: '',
      preview,
      params: {
        elements: ['url_slug'],
        'system.type[in]': ['store_page'],
        language,
      },
    })
    fetchStoreSlugs.items.forEach((item) => {
      if (item.system.language === language) {
        paths.push({
          params: {
            lang: language,
            slug: [storesPage.elements.url_slug.value, item.elements.url_slug.value],
          },
          pageType: item.system.type,
          lastmod: item.system.last_modified,
        })
      }
    })

    // Get tour detail pages
    const toursPage = filteredItems.find((item) => item.system.type === 'tours_page')
    const fetchToursSlugs: MultipleItemResponse<any> = await fetchContent({
      path: '',
      preview,
      params: {
        elements: ['url_slug'],
        'system.type[in]': ['tour_page'],
        language,
      },
    })
    fetchToursSlugs.items.forEach((item) => {
      if (item.system.language === language) {
        paths.push({
          params: {
            lang: language,
            slug: [toursPage.elements.url_slug.value, item.elements.url_slug.value],
          },
          pageType: item.system.type,
          lastmod: item.system.last_modified,
        })
      }
    })

    // Get arrangements detail pages
    const fetchArrangementsSlugs: MultipleItemResponse<any> = await fetchContent({
      path: '',
      preview,
      params: {
        elements: ['url_slug'],
        'system.type[in]': ['arrangement_page'],
        language,
      },
    })
    fetchArrangementsSlugs.items.forEach((item) => {
      if (item.system.language === language) {
        paths.push({
          params: {
            lang: language,
            slug: [
              toursPage.elements.url_slug.value,
              language === 'nl' ? 'arrangementen' : 'arrangements',
              item.elements.url_slug.value,
            ],
          },
          pageType: item.system.type,
          lastmod: item.system.last_modified,
        })
      }
    })

    // Get news detail pages
    const newsPage = filteredItems.find((item) => item.system.type === 'news_overview_page')
    const fetchNewsItemSlugs: MultipleItemResponse<any> = await fetchContent({
      path: '',
      preview,
      params: {
        elements: ['url_slug'],
        'system.type[in]': ['news_item'],
        language,
      },
    })

    fetchNewsItemSlugs.items.forEach((item) => {
      if (item.system.language === language) {
        paths.push({
          params: {
            lang: language,
            slug: [newsPage.elements.url_slug.value, item.elements.url_slug.value],
          },
          pageType: item.system.type,
          lastmod: item.system.last_modified,
        })
      }
    })
  }

  return paths
}
